module.exports = __webpack_public_path__ + "img/docusign.4a628cf3.svg";